import React from "react";
import styled from "styled-components";

import { Editor } from "react-draft-wysiwyg";
import "../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML
} from "draft-js";

const clientId = "72f38e7652c18f4";

const uploadImage = f => {
  return new Promise(function(resolve, reject) {
    const r = new XMLHttpRequest();
    const d = new FormData();
    console.log("Writing", f);
    const e = f;

    d.append("image", e);

    r.open("POST", "https://api.imgur.com/3/image/");
    r.setRequestHeader("Authorization", `Client-ID ${clientId}`);
    r.addEventListener("load", () => {
      const response = JSON.parse(r.responseText);
      resolve(response);
    });
    r.addEventListener("error", () => {
      const error = JSON.parse(r.responseText);
      reject(error);
    });
    r.send(d);
  });
};
const toolbar = {
  options: [
    "inline",
    //"blockType",
    // "fontSize",
    //  "fontFamily",
    "list",
    //    "textAlign",
    "colorPicker",
    "link",
    "emoji"
    // "image"
  ],

  inline: { inDropdown: true },
  list: { inDropdown: true },
  textAlign: { inDropdown: true },
  link: { inDropdown: true },
  history: { inDropdown: true },
  remove: { inDropdown: true },
  image: {
    uploadCallback: uploadImage,
    previewImage: true,
    alt: { present: true, mandatory: false },
    defaultSize: {
      height: "200px",
      width: "auto"
    }
  }
};

const MainDiv = styled.div`
  width: 100%;
  background-color: ${props => "white"};
  padding: 10px;
  border-radius: 3px;
  border: 1px solid ${props => props.theme.color4};
  margin-top: 5px;
  a {
    color: blue;
    text-decoration: underline;
  }
`;

export const Converter = {
  convertToState: text => {
    let editorState = null;
    if (text) {
      const blocksFromHTML = convertFromHTML(text);
      const state = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      if (state.blockMap.size > 0) {
        editorState = EditorState.createWithContent(state);
      }
    }
    return editorState;
  },
  convertFromState: currentText => {
    if (currentText && currentText.getCurrentContent()) {
      const raw = convertToRaw(currentText.getCurrentContent());
      if (raw) {
        return draftToHtml(raw);
      }
    }
    return "";
  }
};

export default ({ editorState, onChange }) => {
  return (
    <MainDiv>
      <Editor
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        value={editorState}
        editorState={editorState}
        onEditorStateChange={onChange}
        toolbar={toolbar}
        hashtag={{
          separator: " ",
          trigger: "#"
        }}
      />
      {/* <Button
        onClick={() => {
          saveText(draftToHtml(convertToRaw(currentText.getCurrentContent())));
        }}
      >
        Save
      </Button> */}
    </MainDiv>
  );
};
